import {IProfile, IUserSession, TRole} from '@verdocs/js-sdk';
import {getHighestRole, RoleOptions} from '../../../react-sdk/roles';
import {TBadgeTone} from '../../../Components';
import {AppState} from '../../../AppState';

const ROLE_RANK: Partial<Record<TRole, number>> = {owner: 3, admin: 2};
export const roleRank = (roles: TRole[] = []) => Math.max(0, ...roles.map((r) => ROLE_RANK[r] || 0));

export const ROLE_LABEL: Record<TRole, string> = {
  owner: 'Owner',
  admin: 'Admin',
  member: 'Member',
  basic_user: 'Basic user',
  contact: 'Contact',
};

const ROLE_TONE: Record<TRole, TBadgeTone> = {
  owner: 'info',
  admin: 'info',
  member: 'muted',
  basic_user: 'muted',
  contact: 'muted',
};

export const roleBadge = (roles: TRole[] = []) => {
  const role = getHighestRole(roles);
  return role ? {label: ROLE_LABEL[role] || role, tone: ROLE_TONE[role] || 'muted'} : null;
};

export const memberName = (member?: {first_name?: string | null; last_name?: string | null; email?: string | null} | null) =>
  [member?.first_name, member?.last_name].filter(Boolean).join(' ') || member?.email || 'this member';

// Mirrors the API's rank rules
export const getCallerAccess = () => {
  const profile = AppState.currentProfile;
  const session = AppState.authSession as Partial<IUserSession> | null;
  const isGlobalAdmin = !!session?.['https://verdocs.com/global_admin'];
  const roles = profile?.roles || [];
  const isAdmin = isGlobalAdmin || roles.some((r) => r === 'owner' || r === 'admin');
  const rank = isGlobalAdmin ? ROLE_RANK.owner! : roleRank(roles);
  const profileId = profile?.id || '';

  return {
    profileId,
    isAdmin,
    isOwner: rank >= ROLE_RANK.owner!,
    canManage: (member: IProfile) => isAdmin && member.id !== profileId && roleRank(member.roles) <= rank,
    canManageRoles: (roles: TRole[]) => isAdmin && roleRank(roles) <= rank,
    assignableRoleOptions: RoleOptions.filter((option) => roleRank([option.value]) <= rank),
  };
};
